import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'admin-buyer-configuration-grace-period',
    template: `
        <buyer-configuration-section
            [hasClickedSave]="hasClickedSave"
            sectionTitle="Buyer Grace Period"
            sectionFormControlName="gracePeriodEnabled"
            [sectionFormGroup]="gracePeriodFormGroup"
        >
            <form [formGroup]="gracePeriodFormGroup" [style.padding]="'2rem 3rem'">
                <div class="row">
                    <div class="col-12" [style.marginBottom]="'1rem'">
                        <lsq-label
                            label="Buyer Grace Period*"
                            subLabel="The number of days for which late fees should not be charged to a buyer post the due date of an invoice."
                        ></lsq-label>
                        <lsq-input
                            [basicLabel]="true"
                            name="gracePeriodDays"
                            formControlName="gracePeriodDays"
                            [group]="gracePeriodFormGroup"
                            [digitsOnly]="true"
                        >
                        </lsq-input>
                    </div>
                </div>
            </form>
        </buyer-configuration-section>
    `
})
export class AdminBuyerConfigurationGracePeriodComponent {
    @Input() public gracePeriodFormGroup: FormGroup;
    @Input() public hasClickedSave: boolean;
}
